module.exports = __webpack_public_path__ + "9ac5a775311bd6156cbc998b63c06574.svg";